import { Vertical, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Select, type SelectProps } from 'antd'

type SupplyOptionSelectProps = {
  title: string | React.ReactNode
  right?: React.ReactNode
  hideSelect?: boolean
} & SelectProps

export function SupplyFilterSelect({ title, right, hideSelect, ...rest }: SupplyOptionSelectProps) {
  return (
    <Vertical gap='1px'>
      <Horizontal justifyContent='space-between'>
        <Texto>{title}</Texto>
        {right}
      </Horizontal>
      <Select
        className={`supply-filter-select ${hideSelect ? 'hidden' : 'visible'}`}
        allowClear
        placeholder='All'
        maxTagCount='responsive'
        optionFilterProp='label'
        {...rest}
      />
    </Vertical>
  )
}
